import { Typography } from '@/ui';

const Delete = () => (
  <Typography variant="body1">
    Are you sure you want to delete this document? This action cannot be undone.
  </Typography>
);

export default Delete;
